export const stockStatus = {
  OUT_OF_STOCK: 'out of stock',
  IN_STOCK: 'in stock',
};
